"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormConstructor = void 0;

var react_1 = __importStar(require("react"));

var formik_1 = require("formik");

var Utils_1 = require("./Utils");

var clsx_1 = __importDefault(require("clsx"));

exports.FormConstructor = function (_a) {
  var validationSchema = _a.validationSchema,
      _b = _a.initialValues,
      initialValues = _b === void 0 ? {} : _b,
      className = _a.className,
      props = __rest(_a, ["validationSchema", "initialValues", "className"]);

  var _c = __read(Utils_1.getFormatedForm(validationSchema, initialValues), 2),
      schema = _c[0],
      values = _c[1];

  var children = props.children;

  var form = __rest(react_1.useRef(), []);

  var classes = clsx_1.default('row', className);
  react_1.useEffect(function () {
    if (form.current) {
      form.current.validateForm();
    }
  }, []);
  return react_1.default.createElement(formik_1.Formik, __assign({}, props, {
    initialValues: values,
    validationSchema: schema,
    innerRef: form,
    validateOnBlur: false,
    validateOnChange: true
  }), function (props) {
    return react_1.default.createElement(formik_1.Form, {
      className: classes
    }, children(__assign({}, props)));
  });
};

exports.default = exports.FormConstructor;